import { z } from "zod";
import sceneObjectDataSchema from "./sceneObjectDataSchema";
import { vector3dSchema } from "../../primitivesSchema";
import apiPlacementSchema from "../../placementSchema";

const circleAnnotationDataSchema = sceneObjectDataSchema.extend({
    placement: apiPlacementSchema,
    radius: z.number(),
    depth: z.number(),
    extrudedDirection: vector3dSchema,
    fontSize: z.number().optional(),
    showAreaText: z.boolean().optional(),
    showVolume: z.boolean().optional()
  });

export default circleAnnotationDataSchema;
